export default __webpack_public_path__ + "static/media/skirmishers_staff.7ea25820.jpg";